
import {app} from "./app/instance.js";
import {initRoutes} from "./app/boot/initRoutes.js";
import {initView} from "./app/boot/initView.js";
import {initCore} from "./app/boot/initCore.js";
import {SettingsRepository} from "./app/SettingsRepository.js";
import {initCrm} from "./crm/boot/initCrm.js";
import {initTimesheet} from "./timesheet/boot/initTimesheet.js";
import {initTimePlan} from "./time-plan/boot/initTimePlan.js";
import '@jamescoyle/svg-icon'
import PlannedTimeRepository from "./time-plan/PlannedTimeRepository.js";

/* app.booting.listen( () => {

});*/

app.booted.listen( () => {
    initCore(app);
    initView(app);
    initCrm(app);
    initTimesheet(app);
    initTimePlan(app);

    let urlParams = new URLSearchParams(window.location.search);
    let intendedUrl = urlParams.get('_intended_url');

    initRoutes(document.getElementById('main-container'), intendedUrl || "/home");
});


await app.boot();